var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsIconPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#037450",
    d: "M11 15.4c2.936 0 5.102.762 6.267 2.205.872 1.08.892 2.185.892 2.195 0 .22-.19.4-.421.4H4.264a.411.411 0 0 1-.421-.398c0-.01.02-1.116.89-2.197C5.897 16.162 8.065 15.4 11 15.4zm0-9.6c2.088 0 3.79 1.615 3.79 3.6S13.087 13 11 13s-3.79-1.615-3.79-3.6S8.913 5.8 11 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.7,
    d: "M12 13.6c1.788 0 3.319.264 4.552.785 1.01.425 1.823 1.022 2.416 1.775C19.988 17.452 20 18.745 20 18.8c0 .662-.567 1.2-1.263 1.2H5.263C4.567 20 4 19.462 4 18.8v-.039c.009-.231.097-1.417 1.032-2.601.593-.753 1.406-1.35 2.416-1.775C8.68 13.864 10.212 13.6 12 13.6zm0 .8c-2.936 0-5.104.762-6.266 2.205-.872 1.081-.891 2.186-.891 2.197 0 .219.19.398.421.398h13.474c.231 0 .42-.18.42-.4 0-.01-.019-1.114-.891-2.195C17.102 15.162 14.936 14.4 12 14.4zM12 4c2.554 0 4.632 1.974 4.632 4.4S14.554 12.8 12 12.8s-4.632-1.974-4.632-4.4S9.446 4 12 4zm0 .8c-2.088 0-3.79 1.615-3.79 3.6S9.913 12 12 12s3.79-1.615 3.79-3.6S14.087 4.8 12 4.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsIconPerson);
export default __webpack_public_path__ + "static/media/icons-icon-person.610012747f09954e9328cd64039101d6.svg";
export { ForwardRef as ReactComponent };